/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MSidebarMenuDetailInfoComponent as ɵa} from './sidebar-menu-detail-info.component';
export {MSidebarMenuShortcutComponent as ɵb} from './sidebar-menu-shortcut.component';